import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { storeLinksFor } from "../../data/storeLinks";
import StoreLinks from "../StoreLinks";

const BuyBookModal = ({ novel, onClose }) => {
  const stores = storeLinksFor(novel.id);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    // Stop the page behind the popup from scrolling with it
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previous;
    };
  }, [onClose]);

  return (
    <div
      className="w-full h-dvh bg-black/80 backdrop-blur-sm flex justify-center items-center fixed top-0 left-0 z-50 p-4"
      onClick={onClose}
    >
      <div
        className="review-success-pop relative w-full max-w-[620px] max-h-[85dvh] flex flex-col rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-[#1f2224]"
        // The backdrop closes the popup; clicks inside it must not bubble up
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close sits inside the panel — hanging it outside got clipped by the
            scroll container and disappeared on small screens. */}
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-black/30 hover:bg-red-500 text-white/80 hover:text-white flex items-center justify-center transition-colors"
        >
          <FontAwesomeIcon icon={faXmark} className="text-[15px]" />
        </button>

        <div className="px-6 pt-6 pb-4 bg-gradient-to-b from-[#2aa9a0]/25 to-transparent">
          <p className="text-[#2aa9a0] text-[11px] font-bold tracking-[0.15em] uppercase">
            Available now
          </p>
          <h3 className="text-white times-new-roman text-[22px] md:text-[26px] font-bold leading-snug mt-1 pr-8">
            {novel.title}
          </h3>
          <p className="text-[#B9B3B9] text-[13px] mt-1">
            Choose a store to read or buy this book.
          </p>
        </div>

        <div className="px-6 pb-6 overflow-y-auto custom-scrollbar">
          <StoreLinks stores={stores} />
        </div>
      </div>
    </div>
  );
};

export default BuyBookModal;
